/**
 * Phase 2 · client-side mirror of backend
 * `order_services/quote_adjustments.compute_revised_totals`.
 * Pure functions only — no React, no imports. Kept isolated so it
 * can be unit-tested without the full component's transitive
 * dependencies.
 */
export const money = (x) => Math.round(Number(x || 0) * 100) / 100;

export function computeRevisedTotals(snapshot, discount, customItems) {
  const merchSubtotal = money(snapshot?.totals?.subtotal ?? 0);
  const taxRate = Number(snapshot?.totals?.tax?.rate ?? 0) || 0;

  let dAmt = 0;
  const dType = discount?.type || "none";
  const dVal = Number(discount?.value || 0);
  if (dType === "percentage") dAmt = money(merchSubtotal * dVal / 100);
  else if (dType === "fixed") dAmt = money(Math.min(dVal, merchSubtotal));

  const merchAfter = money(Math.max(0, merchSubtotal - dAmt));
  const items = customItems || [];
  const taxItems = money(items.filter((i) => i.taxable).reduce((s, i) => s + Number(i.amount || 0), 0));
  const nontaxItems = money(items.filter((i) => !i.taxable).reduce((s, i) => s + Number(i.amount || 0), 0));
  const taxableBase = money(merchAfter + taxItems);
  const taxAmount = money(taxableBase * taxRate);
  const finalTotal = money(taxableBase + taxAmount + nontaxItems);

  return {
    merch_subtotal: merchSubtotal,
    discount_amount: dAmt,
    merch_after_discount: merchAfter,
    custom_taxable_total: taxItems,
    custom_nontaxable_total: nontaxItems,
    taxable_base: taxableBase,
    tax_rate: taxRate,
    tax_amount: taxAmount,
    final_total: finalTotal,
  };
}
